// Code generated by tygo. DO NOT EDIT.

//////////
// source: apikey.go

export interface TmpApiKey extends History {
  /**
   * NOTE: Hash
   */
  Key: string;
  ID: string;
  Type: string;
  Tenant: string;
  TTLUnix: number /* int64 */;
}
export interface TmpApiKeyClaims {
  StandardClaims: any /* jwt.StandardClaims */;
  id: string;
  type: string;
  tenant: string;
}
export type Type = string;
export const TypeLiff: Type = "liff";

//////////
// source: chat_connection.go

export interface ChatConnection {
  id: string;
  tenant: string;
  room_id: string;
  user: string;
  guest: string;
}
export const ChatConnectionTableName = "chat-connection";

//////////
// source: delivery_target.go

/**
 * DeliveryTargetType は配信対象の「種別」マスタ。
 * 選択データには表示ラベルではなく ID を保存するため、ラベルのリネームが可能。
 */
export interface DeliveryTargetType extends History {
  id: string;
  tenant_id: string;
  name: string;
  sort_order: number /* int */;
  is_active: boolean;
}
/**
 * DeliveryTargetItem は「種別」に紐づく配信対象の「項目」マスタ。
 */
export interface DeliveryTargetItem extends History {
  id: string;
  tenant_id: string;
  type_id: string;
  name: string;
  sort_order: number /* int */;
  is_active: boolean;
}
/**
 * DeliveryTargetSelection は LINE ユーザー ID と配信対象項目のペア。
 * ID は "{tenantID}:{lineUID}:{itemID}" の複合キーで保存を冪等にする。
 * GSI:
 *   - line-uid-index: LINE ユーザー ID から選択済み項目を引く (設定 LIFF ページのレンダリング用)
 *   - item-id-index: 項目から LINE ユーザー ID を引く (将来的なセグメント配信の対象抽出用)
 */
export interface DeliveryTargetSelection extends History {
  id: string;
  tenant_id: string;
  line_uid: string;
  item_id: string;
}
export const DeliveryTargetTypeTableName = "delivery_target_type";
export const DeliveryTargetItemTableName = "delivery_target_item";
export const DeliveryTargetSelectionTableName = "delivery_target_selection";

//////////
// source: guest.go

export interface Guest extends History {
  id: string;
  tenant: string;
  type: GuestType;
  line_uid: string;
  name: string;
  avatar: string;
  status_message: string;
  language: string;
  blocked: GuestBlockState;
  notification_tags: string[];
  notification_enabled: boolean;
  last_notification_at?: string /* RFC3339 */;
  /**
   * Attributes holds segment attributes collected from surveys etc.
   * key: survey question id, value: answer
   */
  attributes?: { [key: string]: string};
}
export interface SegmentCondition {
  key: string; // attribute key (survey question id)
  values: string[]; // OR match against the attribute value
  match?: string; // "exact" (default) | "contains"
}
export type GuestType = number /* int */;
export type GuestBlockState = number /* int */;
export const GuestWeb: GuestType = 0 + 1;
export const GuestLine: GuestType = 1 + 1;
export const GuestUnblocked: GuestBlockState = 0 + 1;
export const GuestBlocked: GuestBlockState = 1 + 1;
export const GuestTableName = "guest";

//////////
// source: line.go

export interface Line extends History {
  id: string;
  tenant: string;
  channel_id: string;
  channel_secret: string;
  long_term_token: string;
}
export const LineTableName = "line";

//////////
// source: message.go

export interface Message {
  id: string;
  room: string;
  guest: string;
  user: string;
  type?: string; // "" | "text" | "image"
  body: string;
  image_url?: string;
  raw: string;
  created: string /* RFC3339 */;
  updated: string /* RFC3339 */;
}
export const MessageTableName = "message";
export const MessageTypeText = "text";
export const MessageTypeImage = "image";

//////////
// source: model.go

export interface History {
  created: string /* RFC3339 */;
  updated: string /* RFC3339 */;
}

//////////
// source: notification_delivery.go

export interface NotificationDelivery {
  id: string;
  notification_id: string;
  guest_id: string;
  room_id: string;
  message_id: string;
  status: string;
  delivered_at?: string /* RFC3339 */;
  error?: string;
  created: string /* RFC3339 */;
  updated: string /* RFC3339 */;
}
export const NotificationDeliveryTableName = "notification_delivery";
export const DeliveryStatusProcessing = "processing";
export const DeliveryStatusDelivered = "delivered";
export const DeliveryStatusFailed = "failed";

//////////
// source: notification_history.go

export interface NotificationContent {
  title: string;
  message: string;
  message_type?: string; // "" | "text" | "image" | "flex"
  image_url?: string;
  flex_message?: string;
}
export interface NotificationHistory extends History {
  id: string;
  tenant_id: string;
  type: string; // broadcast | multicast | targeted | test
  title: string;
  message: string;
  tags: string[];
  target_count: number /* int */;
  delivered_count: number /* int */;
  failed_count: number /* int */;
  /**
   * Segment attribute conditions applied to the delivery.
   */
  attribute_filters?: SegmentCondition[];
  /**
   * 配信種別 (LIFF) で選択された項目 ID。type=multicast の対象抽出に使う。
   */
  delivery_target_item_ids?: string[];
  message_type?: string; // "" | "text" | "image" | "flex"
  image_url?: string;
  flex_message?: string;
  /**
   * Status: "scheduled" | "sending" | "sent" | "failed" | "cancelled".
   * Empty for legacy records (= sent).
   */
  status?: string;
  scheduled_at?: string /* RFC3339 */;
  sent_at: string /* RFC3339 */;
  completed_at?: string /* RFC3339 */;
}
export const NotificationHistoryTableName = "notification_history";
/**
 * NotificationType は配信方式の種別。
 * broadcast: LINE Broadcast API で公式アカウントの全フレンドへ、
 * multicast: LIFF 配信種別の選択者へ LINE Multicast API (SQS FIFO で分割)、
 * targeted: タグ/属性で抽出したゲストへ個別 Push。
 */
export const NotificationTypeBroadcast = "broadcast";
/**
 * NotificationType は配信方式の種別。
 * broadcast: LINE Broadcast API で公式アカウントの全フレンドへ、
 * multicast: LIFF 配信種別の選択者へ LINE Multicast API (SQS FIFO で分割)、
 * targeted: タグ/属性で抽出したゲストへ個別 Push。
 */
export const NotificationTypeMulticast = "multicast";
/**
 * NotificationType は配信方式の種別。
 * broadcast: LINE Broadcast API で公式アカウントの全フレンドへ、
 * multicast: LIFF 配信種別の選択者へ LINE Multicast API (SQS FIFO で分割)、
 * targeted: タグ/属性で抽出したゲストへ個別 Push。
 */
export const NotificationTypeTargeted = "targeted";
/**
 * NotificationType は配信方式の種別。
 * broadcast: LINE Broadcast API で公式アカウントの全フレンドへ、
 * multicast: LIFF 配信種別の選択者へ LINE Multicast API (SQS FIFO で分割)、
 * targeted: タグ/属性で抽出したゲストへ個別 Push。
 */
export const NotificationTypeTest = "test";
export const NotificationStatusScheduled = "scheduled";
export const NotificationStatusSending = "sending";
export const NotificationStatusSent = "sent";
export const NotificationStatusFailed = "failed";
export const NotificationStatusCancelled = "cancelled";

//////////
// source: notification_tag.go

export interface NotificationTag extends History {
  id: string;
  tenant_id: string;
  name: string;
  description: string;
  color: string;
  is_active: boolean;
}
export const NotificationTagTableName = "notification_tag";

//////////
// source: room.go

export interface Room extends History {
  id: string;
  name: string;
  description: string;
  tenant: string;
  state: RoomState;
  guest: string;
  user: string;
  /**
   * AssignedAt is set when an operator takes over the room.
   */
  assigned_at?: string /* RFC3339 */;
  last_message_at?: string /* RFC3339 */;
  last_message_preview?: string;
}
export type RoomState = number /* int */;
export const RoomOpen: RoomState = 0 + 1;
export const RoomClose: RoomState = 1 + 1;
export const RoomTableName = "room";

//////////
// source: session.go

export const SessionTableName = "session";
export interface Session {
  ID: string;
  UserID: string;
  TenantID: string;
  CreatedAt: number /* int64 */;
  ExpiresAt: number /* int64 */;
}

//////////
// source: survey.go

export interface SurveyQuestion {
  id: string;
  label: string;
  type: string; // "text" | "select" | "multiselect"
  options?: string[];
}
export interface Survey extends History {
  id: string;
  tenant_id: string;
  title: string;
  description: string;
  questions: SurveyQuestion[];
  is_active: boolean;
}
export const SurveyTableName = "survey";

//////////
// source: tenant.go

export type Plan = number /* int */;
export interface Tenant extends History {
  id: string;
  name: string;
  description: string;
  plan: Plan;
}
export const RootPlan: Plan = 0 + 1;
export const BetaFreePlan: Plan = 1 + 1;
export const TenantTableName = "tenant";

//////////
// source: user.go

export interface User extends History {
  id: string;
  email: string;
  name: string;
  tenant: string;
  role: Role;
}
export type Role = number /* int */;
export interface JwtClaims {
  id: string;
  role: Role;
  tenant: string;
  StandardClaims: any /* jwt.StandardClaims */;
}
export interface NewUserJwtClaims {
  user: string;
  tenant: string;
  role: Role;
  StandardClaims: any /* jwt.StandardClaims */;
}
export const AdminRole: Role = 0 + 1;
export const UserTableName = "user";

//////////
// source: webchat.go

export interface WebChatSetting extends History {
  id: string;
  tenant: string;
  enabled: boolean;
}
export const WebChatSettingTableName = "webchat_setting";
